<template>
    <header>
        <AdUnitTitle
            :adUnit="adUnit"
            :iconColor="consts.COLORS.LIGHT_700"
            bold
        />
        <span class="separator">|</span>
        <Switcher
            :isActive="isActive"
            :uniqueId="`segmentExceptionDeliverySwitch${adUnit}`"
            class="ad-unit-switcher"
            @changed="$emit('update:isActive', $event)"
        />
        <span class="switcher-label font-7" @click="$emit('update:isActive', !isActive)">
            {{isActive ? 'Active' : 'Inactive'}}
        </span>
    </header>
</template>

<script>
import AdUnitTitle from 'components/AdUnitTitle.vue';
import Switcher from 'components/Switcher.vue';
import consts from 'services/metaData/consts';

export default {
    name: 'ExceptionHeader',
    components: { AdUnitTitle, Switcher },
    props: {
        adUnit: {
            type: String,
            required: true,
            validator: (val) => Object.keys(consts.ADUNIT_TO_NAME).includes(val)
        },
        isActive: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        consts: () => consts
    }
};
</script>

<style lang="scss" scoped>
@import "~styles/styleGuide.scss";

header {
    display: flex;
    align-items: center;
    padding: 0 20px;
    height: 60px;
}

.separator {
    margin: 0 8px 2px;
    font-size: 13px;
    color: $light-700;
}

.switcher-label {
    cursor: pointer;
    margin-left: 9px;
    margin-bottom: 3px;
}

.ad-unit-switcher {
    width: 25px;
    height: 15px;
    margin-top: -12px;
    vertical-align: middle;
}
</style>
